import EA from 'helpers/init';

export default EA.Methods.swiperLazyLoad = ($this) => {
    const swiperEl = $this;
    let observer;

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const imgs = swiperEl.querySelectorAll('img');
                for (let i = 0; i < imgs.length; i++) {
                    imgs[i].src = imgs[i].dataset.src;
                }
                observer.disconnect();
            }
        });
    }

    function createObserver() {
        const options = {
            root: null,
            rootMargin: '200px',
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(swiperEl);
    }

    createObserver();
};

